export default __webpack_public_path__ + "static/media/BigData.186dcc126b198f930f52d1e78c91c6e5.webp";